import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';

import { PrismButtonComponent, PrismDialogComponent, PrismDialogRef } from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

@Component({
	selector: 'sh-discovery-error-dialog',
	templateUrl: './discovery-error-dialog.component.html',
	styleUrls: ['./discovery-error-dialog.component.scss'],
	imports: [
		CommonModule,
		FlexLayoutModule,
		PrismDialogComponent,
		TranslocoModule,
		PrismButtonComponent,
		MatDividerModule
	],
	providers: [provideInlineScope('scDiscoveryErrorDialog', (lang) => import(`../i18n/${lang}`))]
})
export class DiscoveryErrorDialogComponent {
	constructor(private readonly dialogRef: PrismDialogRef<DiscoveryErrorDialogComponent>) {}

	public close(): void {
		this.dialogRef.close();
	}
}
